export default {
  header: '',
  loader: '',
  item: function item(_item) {
    return JSON.stringify(_item);
  }
};